import React, { useCallback, useEffect, useState } from 'react';
import { getCurrentUser } from 'aws-amplify/auth';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import { persistor } from '../store';
import { recordDeviceAcceptance } from '../store/deviceTermsSlice';
import { deviceTermsKey, TermsCacheEntry } from '../auth/deviceTerms';
import { useTermsStatus } from '../auth/useTermsStatus';
import TermsAcceptanceModal from './TermsAcceptanceModal';

export default function TermsAcceptanceGate({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, isLoading } = useAuth();
  const username = useAppSelector(state => state.app.userId);
  const entries = useAppSelector(state => state.deviceTerms.byAccount);
  const dispatch = useAppDispatch();
  const { pathname } = useLocation();
  const [identity, setIdentity] = useState({ username: '', sub: '' });
  useEffect(() => {
    let active = true;
    setIdentity({ username: '', sub: '' });
    if (isAuthenticated && !isLoading) void getCurrentUser().then(user => {
      if (active) setIdentity({ username: user.username, sub: user.userId });
    }).catch(() => {});
    return () => { active = false; };
  }, [isAuthenticated, isLoading, username]);
  const sub = isAuthenticated && !isLoading && identity.username === username ? identity.sub : '';
  const key = deviceTermsKey(sub);
  const save = useCallback((entry: TermsCacheEntry) => {
    dispatch(recordDeviceAcceptance({ key, receipt: entry }));
    void persistor.flush().catch(() => {});
  }, [dispatch, key]);
  const { needsAcceptance, busy, accept } = useTermsStatus(sub, pathname === '/my-stories', entries[key], save, () => crypto.randomUUID());
  return <>{children}{needsAcceptance && <TermsAcceptanceModal busy={busy} accept={accept} />}</>;
}
